import { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const HowItWorks = () => {
  const steps = [
    {
      number: 1,
      title: "Placera dina ankarpunkter",
      description:
        "Fäst kabelankarna i stabila fästpunkter och anslut till ORBIT.",
    },
    {
      number: 2,
      title: "Montera kameran",
      description:
        "Montera valfri kamera upp till 3 kg i vårt universella fästsystem.",
    },
    {
      number: 3,
      title: "Anslut appen",
      description:
        "Anslut till ORBIT Cable Cam via Bluetooth och följ den interaktiva installationsguiden.",
    },
    {
      number: 4,
      title: "Skapa imponerande material",
      description:
        "Du är nu redo att filma - appen ger dig full kontroll över rörelser, vinklar och hastigheter upp till 35 km/h.",
    },
  ];

  // gallery images per tier (can be extended later)
  const enkelImages = ["/product_1.png"];
  const standardImages = ["/product_1.png", "/product_2.png"];
  const avanceradImages = [
    "/product_1.png",
    "/product_2.png",
    "/product_3.png",
  ];

  const [standardIndex, setStandardIndex] = useState(0);
  const [avanceradIndex, setAvanceradIndex] = useState(0);

  return (
    <div className="min-h-screen">
      <Header />

      <section className="py-16 px-6 bg-background">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-5xl font-bold mb-8 text-center">
            Hur funkar det?
          </h1>
          <p className="text-foreground leading-relaxed mb-16">
            Snabb att sätta upp - kraftfullt i resultat. Med ORBIT Cable Cam
            skapar du professionella kamerarörelser på bara några minuter, tack
            vare ett portabelt system som enkelt kan transporteras och snabbt
            riggas upp på plats. Systemet är utvecklat för att vara intuitivt,
            pålitligt och effektivt - utan behov av tekniker eller
            specialverktyg.
          </p>

          <h2 className="text-4xl font-bold mb-4 text-center">
            Enkel installation
          </h2>
          <p className="text-center text-muted-foreground mb-12">
            Så fungerar det – enkel installation, professionellt resultat
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            {/* <div className="bg-muted rounded-lg overflow-hidden">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover"
              >
                <source src="/video-1.mp4" type="video/mp4" />
              </video>
            </div> */}
            {steps.map((step) => (
              <div key={step.number} className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-bold">
                  {step.number}
                </div>
                <div>
                  <h3 className="font-semibold mb-1">{step.title}</h3>
                  <p className="text-sm text-muted-foreground">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-primary py-16 px-6 relative">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="text-center md:text-left">
              <p className="text-white/90 mb-4">
                Har ni en vision? Låt oss förverkliga den!
              </p>
              <h2 className="text-4xl font-bold text-white mb-8">
                Appen ger er total kontroll
              </h2>
              <div className="flex gap-4 justify-center md:justify-start">
                <a
                  href="https://apps.apple.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/apple-store.png"
                    alt="Download on the App Store"
                    className="h-12"
                  />
                </a>
                <a
                  href="https://play.google.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/google-play-store.png"
                    alt="Get it on Google Play"
                    className="h-12"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* mobile image: absolute on md+, inline on small screens */}
        <div className="hidden md:block absolute right-1/4 top-1/2 transform -translate-y-1/2 pointer-events-none">
          <img
            src="/mobile-new.png"
            alt="App interface"
            className="h-screen max-h-[26rem] object-contain"
          />
        </div>

        <div className="block md:hidden mt-6 flex justify-center">
          <img
            src="/mobile-new.png"
            alt="App interface"
            className="h-80 object-contain"
          />
        </div>
      </section>

      <section className="py-16 px-6 bg-background">
        <div className="container mx-auto max-w-6xl">
          <h2 className="text-4xl font-bold mb-12 text-center">
            Vad ingår i våra paket?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* Tier: Enkel (single image gallery) */}
            <div className="rounded-lg overflow-hidden flex flex-col bg-muted">
              <div className="relative w-full">
                <img
                  src={enkelImages[0]}
                  alt="Enkel"
                  className="w-full h-64 sm:h-64 md:h-48 object-cover"
                />
              </div>
              <div className="p-6 flex flex-col items-center text-center">
                <h4 className="text-xl font-semibold mb-2">Enkel</h4>
                <p className="text-sm text-muted-foreground mb-4">
                  En prisvärd startlösning för enklare projekt.
                </p>
                <ul className="text-left mb-6 space-y-3">
                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">
                      1x ORBIT Kevlarvajersystem (50 m)
                    </span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">1x ORBIT Cable Cam</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">1x Batteri</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">1x Laddare</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">1x Hardcase</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">
                      1x Adapterfästen (DSLR, GoPro, smartphone)
                    </span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">Grundläggande support</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">
                      Tillgång till appens basfunktioner
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Tier: Standard (gallery with arrows) */}
            <div className="rounded-lg overflow-hidden flex flex-col bg-muted">
              <div className="relative w-full">
                <img
                  src={standardImages[standardIndex]}
                  alt="Standard"
                  className="w-full h-64 sm:h-64 md:h-48 object-cover"
                />
                {standardImages.length > 1 && (
                  <>
                    <button
                      onClick={() =>
                        setStandardIndex(
                          (i) =>
                            (i - 1 + standardImages.length) %
                            standardImages.length,
                        )
                      }
                      className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/40 text-white rounded-full p-2"
                      aria-label="Previous image"
                    >
                      ‹
                    </button>
                    <button
                      onClick={() =>
                        setStandardIndex((i) => (i + 1) % standardImages.length)
                      }
                      className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/40 text-white rounded-full p-2"
                      aria-label="Next image"
                    >
                      ›
                    </button>
                  </>
                )}
              </div>
              <div className="p-6 flex flex-col items-center text-center">
                <h4 className="text-xl font-semibold mb-2">Standard</h4>
                <p className="text-sm text-muted-foreground mb-4">
                  Vårt mest populära val för de flesta produktioner.
                </p>
                <ul className="text-left mb-6 space-y-3">
                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">
                      1x ORBIT Kevlarvajersystem (50 m)
                    </span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">1x ORBIT Cable Cam</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">3x Batterier</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">1x Laddare</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">1x Fiberanslutning</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">1x Hardcase</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">
                      1x Adapterfästen (DSLR, GoPro, smartphone)
                    </span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">Prioriterad support</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">
                      Tillgång till appens samtliga funktioner
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Tier: Avancerad (gallery with arrows) */}
            <div className="rounded-lg overflow-hidden flex flex-col bg-muted">
              <div className="relative w-full">
                <img
                  src={avanceradImages[avanceradIndex]}
                  alt="Avancerad"
                  className="w-full h-64 sm:h-64 md:h-48 object-cover"
                />
                {avanceradImages.length > 1 && (
                  <>
                    <button
                      onClick={() =>
                        setAvanceradIndex(
                          (i) =>
                            (i - 1 + avanceradImages.length) %
                            avanceradImages.length,
                        )
                      }
                      className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/40 text-white rounded-full p-2"
                      aria-label="Previous image"
                    >
                      ‹
                    </button>
                    <button
                      onClick={() =>
                        setAvanceradIndex(
                          (i) => (i + 1) % avanceradImages.length,
                        )
                      }
                      className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/40 text-white rounded-full p-2"
                      aria-label="Next image"
                    >
                      ›
                    </button>
                  </>
                )}
              </div>
              <div className="p-6 flex flex-col items-center text-center">
                <h4 className="text-xl font-semibold mb-2">Avancerad</h4>
                <p className="text-sm text-muted-foreground mb-4">
                  Fullt utrustad paket för professionell produktion.
                </p>
                <ul className="text-left mb-6 space-y-3">
                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">
                      2x ORBIT Kevlarvajersystem (50 m)
                    </span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">2x ORBIT Cable Cam</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">5x Batterier</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">2x Laddare</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">2x Fiberanslutning</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">2x Hardcases</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">
                      2x Adapterfästen (DSLR, GoPro, smartphone)
                    </span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">Premium support</span>
                  </li>

                  <li className="flex items-center gap-3">
                    <span className="text-primary font-bold text-lg">✓</span>
                    <span className="text-sm">
                      Tillgång till appens samtliga funktioner
                    </span>
                  </li>
                </ul>
                {/* No CTA button for Avancerad as requested */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HowItWorks;
